 
//função implementada nas chamadas GET para resolver problema de CACHE
//aguardando novo back-end para remover
 export function getDateRequest() {
  return `&time=${new Date().getTime()}`
}